import React from 'react'
import Popup from '../../../common/Popup/Popup'
import ProjectIdTable from './ProjectIdTable'

const ProjectIdPopup = ({onClose,handleSelectProject,useTableInAuditTrail=false, auditTrailRow}) => {
  return <>
    <Popup title={"Project ID Table"} closeModal={onClose}>
        <ProjectIdTable
            handleSelectProject={handleSelectProject}
            useTableInAuditTrail={useTableInAuditTrail}
            auditTrailRow={auditTrailRow}
        />
    </Popup>
  </>
}

export default ProjectIdPopup